/*
  Copyright 2019 Bit Factory, Inc.
  This Source Code Form is subject to the terms of the Mozilla Public
  License, v. 2.0. If a copy of the MPL was not distributed with this
  file, You can obtain one at http://mozilla.org/MPL/2.0/.
*/
import axios from 'axios';
export class RpcClient {
    constructor(endpoint) {
        this.endpoint = endpoint;
    }
    async post(payload) {
        const res = await axios.post(this.endpoint, payload);
        return res.data;
    }
}
